import { render, staticRenderFns } from "./GetFlags.vue?vue&type=template&id=23f2be5d&"
import script from "./GetFlags.vue?vue&type=script&lang=js&"
export * from "./GetFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports